/**
 * Pure helpers for the DB Config screen: map a services-common
 * connection entry to the row shape the table renders, and describe the
 * semantic-layer state for labels.
 */
import { DB_TYPES } from "../../constants/dbConfigData.js";

// Database connections are configured by super administrators only.
export const ADMIN_ROLES = ["super_admin"];

export function isAdminRole(role) {
  return ADMIN_ROLES.includes(String(role || "").toLowerCase());
}

export function mapConnectionEntry(connectionId, entry) {
  const dbType = entry.db_type === "postgres" ? "postgresql" : entry.db_type;
  const typeInfo = DB_TYPES.find((t) => t.value === dbType);
  const conn = entry.conn || {};

  let fields = {};
  if (dbType === "athena") {
    fields = {
      s3StagingDir: conn.s3_staging_dir || "",
      awsRegion: conn.region || "",
      catalog: conn.catalog || "",
      databaseName: conn.database || "",
      workgroup: conn.workgroup || "",
    };
  } else {
    fields = {
      hostname: conn.host || "",
      port: String(conn.port || ""),
      username: conn.user || "",
      password: conn.password || "",
      databaseName: conn.database || "",
    };
  }

  return {
    id: connectionId,
    type: dbType,
    label: typeInfo?.label || dbType,
    icon: typeInfo?.icon || "🗄️",
    connectionId,
    fields,
    semanticFileExists: entry.semantic_file_exists || false,
    // "edited" when an administrator saved text, "generated" when only
    // the discovery-generated document exists, null when neither.
    semanticSource: entry.semantic_source || null,
    discoveryStatus: entry.discovery_status || "none",
    // services-common 0.0.210: a shared connection is visible to, and
    // attachable by, everyone in the organisation.
    shared: Boolean(entry.shared),
    ownerUserId: entry.owner_user_id || null,
    rawConn: conn,
    rawDbType: entry.db_type,
    assignments: { projects: [], teams: [], persons: [] },
  };
}

export function semanticActionLabel(config) {
  if (config?.semanticSource === "generated") return "Review generated semantic layer";
  if (config?.semanticFileExists) return "Edit semantic layer";
  return "Add semantic layer";
}

export function sharingLabel(config) {
  return config?.shared ? "Organisation" : "Private";
}
